import * as React from "react";
const SvgMeals = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 100,
	height: 60,
	viewBox: "0 0 100 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	x: .5,
	y: .5,
	width: 99,
	height: 59,
	rx: 3,
	fill: "#FAFAFA",
	stroke: "#BDBDBD",
	strokeWidth: .25
}), /* @__PURE__ */ React.createElement("rect", {
	className: "meal-main",
	x: 6,
	y: 6,
	width: 62,
	height: 48,
	rx: 2,
	fill: "#E0E0E0",
	stroke: "#BDBDBD",
	strokeWidth: 1
}), /* @__PURE__ */ React.createElement("rect", {
	className: "meal-side",
	x: 72,
	y: 6,
	width: 22,
	height: 22,
	rx: 2,
	fill: "#E0E0E0",
	stroke: "#BDBDBD",
	strokeWidth: 1
}), /* @__PURE__ */ React.createElement("rect", {
	className: "meal-side",
	x: 72,
	y: 32,
	width: 22,
	height: 22,
	rx: 2,
	fill: "#E0E0E0",
	stroke: "#BDBDBD",
	strokeWidth: 1
}));
export default SvgMeals;
